/* eslint-disable no-console */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
// import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import shareProduct from "@insite/client-framework/Store/CommonHandlers/ShareProduct";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { themeColor } from "@TKCCP/Styles/variables";

import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CreateUserAccountParameter } from "@TKCCP/Services/tkccpCreateUserAccountService";
import loadUserAccountDetails from "@TKCCP/Store/Pages/UserAccount/Handlers/LoadUserAccountdetails";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    text?: string;
    extendedStyles?: CreateUserAccountStyles;
    allowGuestCheckout?: boolean;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const mapStateToProps = (state: ApplicationState) => {
    const { search } = getLocation(state);
    const session = state.context.session;
    const createAccountPageLink = getPageLinkByPageType(state, "CreateAccountPage");
    return {
        createAccountUrl: createAccountPageLink ? `${createAccountPageLink.url}${search}` : undefined,
    };
};

const mapDispatchToProps = {
    loadUserAccountDetails,
};

export interface CreateUserAccountStyles {
    link?: LinkPresentationProps;
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    recipientNameGridItem?: GridItemProps;
    recipientNameTextField?: TextFieldProps;
    recipientEmailGridItem?: GridItemProps;
    recipientEmailTextField?: TextFieldProps;
    yourNameGridItem?: GridItemProps;
    yourNameTextField?: TextFieldProps;
    yourEmailGridItem?: GridItemProps;
    yourEmailTextField?: TextFieldProps;
    yourMessageGridItem?: GridItemProps;
    yourMessageTextArea?: TextAreaProps;
    reCaptchaGridItem?: GridItemProps;
    buttonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    validateButton?: ButtonPresentationProps;
    createButton?: ButtonPresentationProps;
    errorMsg?: InjectableCss;
}

export const createUserAccountStyles: CreateUserAccountStyles = {
    modal: {
        size: 600,
        cssOverrides: {
            modalTitle: css`
                padding: 10px 30px;
            `,
            modalContent: css`
                padding: 20px 30px;
            `,
        },
    },
    container: { gap: 10 },
    recipientNameGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            padding-right: 10px;
        `,
    },
    recipientEmailGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            padding-left: 10px;

            &:empty {
                padding: 0;
            }
        `,
    },
    yourNameGridItem: {
        width: 6,
        css: css`
            padding-right: 10px;
        `,
    },
    yourEmailGridItem: {
        width: 6,
        css: css`
            padding-left: 10px;
        `,
    },
    yourMessageGridItem: {
        width: 12,
    },
    yourMessageTextArea: {
        cssOverrides: {
            inputSelect: css`
                resize: none;
            `,
        },
    },
    reCaptchaGridItem: {
        width: 12,
    },
    buttonsWrapper: {
        css: css`
            margin-top: 30px;
            text-align: right;
        `,
    },
    cancelButton: {
        variant: "secondary",
    },
    validateButton: {
        css: css`
            margin-left: 10px;
        `,
    },
    createButton: {
        css: css`
            background:${themeColor.colorLightGrey};
            color: ${themeColor.colorSecondary};
            border-color:${themeColor.colorBorderGrey};
            margin-bottom: 15px;
            width: 100%;
            &:hover{
                background:${themeColor.colorLightGrey};
                color: ${themeColor.colorSecondary};
                border-color:${themeColor.colorBorderGrey};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    errorMsg: {
        css: css`
            color: ${themeColor.colorErrorRed};
            margin-top: 10px;
            font-size: 15px;
            font-weight: 600;
        `,
    },
};

const CeateAccountModal = ({ text, extendedStyles, createAccountUrl, history, loadUserAccountDetails, allowGuestCheckout }: Props) => {
    const toasterContext = React.useContext(ToasterContext);
    const [styles] = React.useState(() => mergeToNew(createUserAccountStyles, extendedStyles));
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const [customerNumber, setCustomerNumber] = React.useState("");
    const [customerNumberError, setCustomerNumberError] = React.useState("");

    const [isFormValid, setIsFormValid] = React.useState(true);
    const [formInvalidMessage, setFormInvalidMessage] = React.useState("");

    const [PostalCode, setPostalCode] = React.useState("");
    const [postalCodeError, setPostalCodeError] = React.useState("");
    const [isCustomerNumberValid, setCustomerNumberValidation] = React.useState(false);
    const [inProgress, setInProgress] = React.useState(false);
    const [shipToPostalCode, setShipToPostalCode] = React.useState([] as string[]);

    const modalCloseHandler = () => {
        setModalIsOpen(false);
        resetFields();
    };

    const postalCodeClickHandler = (postalcode: string) => {
        setPostalCode(postalcode);
    };

    const requiredFieldMessage = translate("This is a required field");
    const checkForErrors = () => {
        if (!isCustomerNumberValid) {
            const localCustomerNumberErrorMessage = !customerNumber ? requiredFieldMessage : "";
            setCustomerNumberError(localCustomerNumberErrorMessage);
            return !!localCustomerNumberErrorMessage;
        }

        const localPostalCodeErrorMessage = !PostalCode ? requiredFieldMessage : "";
        setPostalCodeError(localPostalCodeErrorMessage);

        return !!localPostalCodeErrorMessage;
    };

    const resetFields = () => {
        setCustomerNumber("");
        setPostalCode("");
        setCustomerNumberError("");
        setPostalCodeError("");
        setInProgress(false);
        setIsFormValid(true);
        setFormInvalidMessage("");
        setCustomerNumberValidation(false);
    };

    const customerNumberClickeHandler = (customerNumber: string) => {
        setCustomerNumber(customerNumber);
    };
    const sharedSecretChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        // setsharedSecret(event.target.value);
        setPostalCodeError(!event.target.value ? requiredFieldMessage : "");
    };

    const shareLinkClickHandler = () => {
        resetFields();
        // const secret = generateRandomNumber();
        // // setsharedSecret(keyid);
        // // eslint-disable-next-line no-console
        // setsharedSecret(secret);
        setModalIsOpen(true);
    };

    const setFormValidation = (valid: boolean, message: string) => {
        setIsFormValid(valid);
        setFormInvalidMessage(message);
    };

    const shareButtonClickHandler = async () => {
        if (checkForErrors()) {
            return;
        }
        if (!createAccountUrl) {
            return;
        }
        setModalIsOpen(true);
        if (!isCustomerNumberValid) {
            const result = await loadUserAccountDetails({
                customerNumber,
                onSuccess: response => {
                    if (
                        response !== null &&
                        response !== undefined &&
                        response.customerExist !== null &&
                        response.customerExist !== undefined &&
                        response.status === 200 &&
                        response.shipToPostalCodes !== null &&
                        response.shipToPostalCodes !== undefined &&
                        response.shipToPostalCodes.length > 0
                    ) {
                        if (response.customerExist) {
                            setCustomerNumberValidation(true);
                            setShipToPostalCode(response.shipToPostalCodes);
                            setFormValidation(true, "");
                        } else {
                            setCustomerNumberValidation(false);
                            setFormValidation(false, `Invalid customer number ${customerNumber}.`);
                        }
                    } else {
                        setCustomerNumberValidation(false);
                        setFormValidation(false, `Invalid customer number ${customerNumber}.`);
                    }
                },
            });
        } else {
            // eslint-disable-next-line no-lonely-if
            if (shipToPostalCode && shipToPostalCode.length > 0) {
                if (shipToPostalCode.includes(PostalCode)) {
                    setModalIsOpen(true);
                    setFormValidation(true, "");
                    const queryString = `customernumber=${customerNumber}&postalcode=${PostalCode}`;
                    history.push(`/MyAccount/CreateAccount?${queryString}`);
                    // history.push(`${createAccountUrl}?${queryString}`);
                } else {
                    setFormValidation(false, `Invalid postal code for customer number ${customerNumber}.`);
                }
            } else {
                setFormValidation(false, `Postal code not available for  customer number ${customerNumber}.`);
            }
        }
    };

    return (
        <>
            <Button onClick={shareLinkClickHandler} {...styles.createButton} data-test-selector="productShareLink">
                {text || translate("Request Online Access")}
            </Button>
            <Modal
                {...styles.modal}
                headline={translate("Create Account")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                <GridContainer {...styles.container} data-test-selector="CreateAccountModal">
                    <GridItem {...styles.recipientNameGridItem}>
                        <TextField
                            label={translate("Customer Number")}
                            value={customerNumber}
                            error={customerNumberError}
                            onChange={e => customerNumberClickeHandler(e.currentTarget.value)}
                            data-test-selector="CreateAccount_CustomerNumber"
                            {...styles.recipientNameTextField}
                        />
                    </GridItem>
                    <GridItem {...styles.recipientEmailGridItem}>
                        {isCustomerNumberValid && (
                            <TextField
                                label={translate("Postal Code")}
                                value={PostalCode}
                                error={postalCodeError}
                                onChange={e => postalCodeClickHandler(e.currentTarget.value)}
                                data-test-selector="CreateAccount_PostalCode"
                                {...styles.recipientEmailTextField}
                            />
                        )}
                    </GridItem>
                </GridContainer>
                <StyledWrapper {...styles.errorMsg}>{!isFormValid && <span>{formInvalidMessage}</span>}</StyledWrapper>
                <StyledWrapper {...styles.buttonsWrapper}>
                    <Button
                        {...styles.cancelButton}
                        onClick={modalCloseHandler}
                        data-test-selector="CreateAccount_Cancel"
                    >
                        {translate("Cancel")}
                    </Button>
                    <Button
                        {...styles.validateButton}
                        onClick={shareButtonClickHandler}
                        data-test-selector="customerValidate"
                        // disabled={inProgress}
                    >
                        {translate("Validate")}
                    </Button>
                </StyledWrapper>
            </Modal>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(CeateAccountModal);
